module.exports = __webpack_public_path__ + "media/2.1815be94.mp3";